/**
 * 侧栏导航的唯一数据源。AdminShell 只按组渲染，不再手写几十个 RouterLink。
 * 分组顺序就是运营的日常动线：先看用户和收入，再看报表，然后是内容生产，最后是模型（仅 admin）。
 * 组标题取 `visualGameAdmin.app.groups.<key>`，链接文案取 `label` 指向的完整 i18n key。
 */
import {
  Activity,
  ChartGantt,
  ChartNoAxesCombined,
  ChartPie,
  Clapperboard,
  ClipboardCheck,
  CloudUpload,
  Coins,
  Cpu,
  Film,
  FolderOpen,
  Funnel,
  Gamepad2,
  History,
  GalleryHorizontalEnd,
  KeyRound,
  Layers,
  Library,
  Link2,
  ListChecks,
  ListVideo,
  MessagesSquare,
  MousePointerClick,
  Package,
  Receipt,
  Route,
  Scale,
  ScrollText,
  Search,
  Settings,
  SlidersHorizontal,
  Tags,
  TextQuote,
  TicketCheck,
  Users,
  UsersRound,
} from '@lucide/vue'

export const ADMIN_NAV_GROUPS = [
  {
    key: 'growth',
    links: [
      { to: '/waitlist', icon: ListChecks, label: 'visualGameAdmin.app.waitlist' },
      { to: '/invitation-codes', icon: TicketCheck, label: 'visualGameAdmin.app.invitationCodes' },
      { to: '/users', icon: UsersRound, label: 'visualGameAdmin.app.users' },
    ],
  },
  {
    key: 'billing',
    links: [
      { to: '/billing/dashboard', icon: ChartPie, label: 'visualGameAdmin.billing.dashboard.nav' },
      { to: '/billing/policies', icon: SlidersHorizontal, label: 'visualGameAdmin.billing.policies.title' },
      { to: '/billing/products', icon: Package, label: 'visualGameAdmin.billing.products.title' },
      { to: '/billing/orders', icon: Receipt, label: 'visualGameAdmin.billing.orders.title' },
      { to: '/billing/ledger', icon: Coins, label: 'visualGameAdmin.billing.ledger.title' },
    ],
  },
  {
    key: 'analytics',
    links: [
      { to: '/promotions', icon: Link2, label: 'visualGame.promotion.admin.title' },
      { to: '/analytics/conversion-funnel', icon: Funnel, label: 'visualGameAdmin.app.conversionFunnel' },
      { to: '/analytics', icon: ChartNoAxesCombined, label: 'visualGameAdmin.app.analytics' },
      { to: '/analytics/content', icon: Film, label: 'visualGameAdmin.app.contentAnalytics' },
      { to: '/analytics/ga4', icon: MousePointerClick, label: 'visualGameAdmin.app.ga4Behavior' },
    ],
  },
  {
    key: 'content',
    links: [
      { to: '/generation-records', icon: Clapperboard, label: 'visualGameAdmin.app.generationRecords' },
      { to: '/creator-projects', icon: Gamepad2, label: 'visualGameAdmin.app.ugcReview' },
      { to: '/tags', icon: Tags, label: 'visualGameAdmin.app.tagManagement' },
      { to: '/game-releases', icon: CloudUpload, label: 'visualGameAdmin.app.gameReleases' },
      { to: '/homepage-carousel', icon: GalleryHorizontalEnd, label: 'visualGameAdmin.app.homepageCarousel' },
      { to: '/homepage-popular-pins', icon: ListChecks, label: 'visualGameAdmin.app.homepagePopularPins' },
      { to: '/asset-library', icon: Library, label: 'visualGameAdmin.app.assetLibrary' },
      { to: '/prompt-library', icon: TextQuote, label: 'visualGameAdmin.app.promptLibrary' },
      { to: '/entity-library', icon: Users, label: 'visualGameAdmin.app.entityLibrary' },
    ],
  },
  {
    key: 'intentVideos',
    links: [
      { to: '/intent-videos/preparation', icon: ClipboardCheck, label: 'visualGameAdmin.intentVideo.tabs.preparation' },
      { to: '/intent-videos/clusters', icon: Layers, label: 'visualGameAdmin.intentVideo.tabs.clusters' },
      { to: '/intent-videos/queue', icon: ListVideo, label: 'visualGameAdmin.intentVideo.tabs.queue' },
      { to: '/intent-videos/resources', icon: FolderOpen, label: 'visualGameAdmin.intentVideo.tabs.resources' },
      { to: '/intent-videos/recall', icon: Search, label: 'visualGameAdmin.intentVideo.tabs.recall' },
      { to: '/intent-videos/logs', icon: History, label: 'visualGameAdmin.intentVideo.tabs.logs' },
      { to: '/intent-videos/h3-queue', icon: Activity, label: 'visualGameAdmin.intentVideo.tabs.h3Queue' },
    ],
  },
  {
    key: 'modelConfig',
    adminOnly: true,
    links: [
      { to: '/llm/h3-config', icon: Settings, label: 'visualGameAdmin.app.h3Config' },
      { to: '/llm/capabilities', icon: Cpu, label: 'visualGameAdmin.app.modelCapabilities' },
      { to: '/llm/providers', icon: KeyRound, label: 'visualGameAdmin.app.llm' },
      { to: '/llm/modes', icon: Route, label: 'visualGameAdmin.app.llmModes' },
    ],
  },
  {
    key: 'modelObservability',
    adminOnly: true,
    links: [
      { to: '/llm/calls', icon: ScrollText, label: 'visualGameAdmin.app.llmCalls' },
      { to: '/llm/conversations', icon: MessagesSquare, label: 'visualGameAdmin.app.llmConversations' },
      { to: '/llm/turn-timelines', icon: ChartGantt, label: 'visualGameAdmin.app.llmTurnTimelines' },
      { to: '/llm/runtime', icon: Activity, label: 'visualGameAdmin.app.llmRuntime' },
    ],
  },
  {
    key: 'modelFinance',
    adminOnly: true,
    links: [
      { to: '/llm/cost', icon: Coins, label: 'visualGameAdmin.app.llmCost' },
      { to: '/llm/reconciliation', icon: Scale, label: 'visualGameAdmin.app.llmRecon' },
    ],
  },
]
